import { Component, OnInit } from '@angular/core';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DataSharingService } from '../data-sharing.service';
import { FormsModule, NgForm } from '@angular/forms';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-attendance-correction-request',
  templateUrl: './attendance-correction-request.component.html',
  styleUrls: ['./attendance-correction-request.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule]
})
export class AttendanceCorrectionRequestComponent implements OnInit {
  selectedRadio = '';
  public _user_id: any;
  public _attendance_id: any;
  public _check_in: any;
  public _check_out: any;
  public _working_hours: any;
  public _overtime: any;
  public _type: any;
  public _date: any;
  public _reason: any = '';
  public _status: any;
  public old_value: any = '';
  check_in: any

  sharedData: any = { user_id: '', attendance_id: '', date: '', checkin: '', checkout: '', workinghour: '', overtime: '' };
  Totalminutesworked: any;
  old_valueChickin: any;
  // Totalhours: any;
  date: any;
  datamode: any;
  selectedMode: any;
  showSpinner: any;
  userInfo: any;
  colormode: any;
  user: any;
  //  sharedData: any;
  constructor(private attendanceService: AttendanceService,
    public router: Router,
    public dashboardService: DashboardService,

    private dataSharingService: DataSharingService,
    private sharedmode: SharedModeService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');

    this.sharedData = this.dataSharingService.getSharedData();
    this.user_detail();


  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {

      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {

    this.datamode
    this.sharedmode.setMode(mode);
  }


  onSubmit(f: NgForm) {
    if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "checkin") {
      this.old_value = this.sharedData.checkin;
      this._check_in = f.value.checkin;
      this._reason = f.value.reason;
      this._user_id = this.sharedData.user_id;
      this._attendance_id = this.sharedData.attendance_id;
      this._check_out = '';
      this._working_hours = '';
      this._overtime = '';
      this._type = 'check_in';
      this._date = this.sharedData.date;
      this._status = 'pending';

    }
    else if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "checkout") {
      this.old_value = this.sharedData.checkout;
      this.date = this.sharedData.date;
      this.old_valueChickin = this.sharedData.checkin;
      //Combine date and time checkout
      this._check_out = f.value.checkout;
      const combinedchecoutString = `${this.date} ${this._check_out}`;
      const combinedcheckout = new Date(combinedchecoutString);
      // Format the date
      const formattedCheckOut = combinedcheckout;
      this._check_out = f.value.checkout;
      this._reason = f.value.reason;
      this._user_id = this.sharedData.user_id;
      this._attendance_id = this.sharedData.attendance_id;
      this._check_in = '';
      // Correct total Hours Calculation
      const currentDate = formattedCheckOut; //#NEED TO CHANGE CHECKOUT - tAGETED
      const mn = currentDate.getMonth() + 1
      const month = (mn < 10) ? `0${mn}` : (mn)
      const checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
      const checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
      let totalHours = 0;
      if (this.old_valueChickin != "" && this.old_valueChickin != null) {
        totalHours = Math.abs(new Date(`${checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.date} ${this.old_valueChickin}`).getTime()) / 36e5;
        totalHours = totalHours < 0 ? totalHours * (-1) : totalHours;
      }

      this._working_hours = totalHours.toFixed(2);
      this._overtime = '';
      this._type = 'check_out';
      this._date = this.sharedData.date;
      this._status = 'pending';
    }
    else if (f.value.correction !== null && f.value.correction !== undefined && f.value.correction === "overtime") {
      this.old_value = this.sharedData.overtime;
      this._overtime = f.value.overtime;
      this._reason = f.value.reason;
      this._user_id = this.sharedData.user_id;
      this._attendance_id = this.sharedData.attendance_id;
      this._check_in = '';
      this._check_out = '';
      this._working_hours = '';
      this._type = 'overtime';
      this._date = this.sharedData.date;
      this._status = 'pending';
    }

    // muneeb

    this.attendanceService

      .attendanceCorrection(
        this._user_id,
        this._attendance_id,
        this._check_in,
        this._check_out,
        this._working_hours,
        this._overtime,
        this._type,
        this._date,
        this._reason,
        this._status,
        this.old_value
      )


      .then((value) => {
        // this.showSpinner = false;

        this.router.navigate(['/attendance']);
        if (value.success == true) {

          if (value.data?.warning === 'limit_exceeded') {
            Swal.fire({
              icon: 'warning',
              title: 'Monthly Limit Reached',
              text: 'You have already used your 2 requests this month. This request may not be approved.',
              confirmButtonText: 'Understood',
            });
          } else {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
              title: 'Applied Successfully',
              showConfirmButton: false,
              timer: 1500,
            });
          }

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });



  }

  back() {
    this.router.navigate(['/attendance']);
  }

  trimText() {
    this._reason = this._reason.replace(/\s+/g, ' ').trim();
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}
